"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { apiClientCommon } from "services/apiClientCommon";
import { selectUser } from "stores/auth/authSlice";
import { useAppSelector } from "stores/hooks";
const AppUTMSessionManagement = () => {
  const params = useSearchParams();
  const loggedInUserDetail = useAppSelector(selectUser);
  useEffect(() => {
    if (!params) return;
    void (async () => {
      const utmMedium = params.get("utm_medium");
      if (utmMedium) {
        const paramObject: Record<string, string> = {};
        params.forEach((value, key) => paramObject[key] = value);
        sessionStorage.setItem("utm_campaign_data", JSON.stringify(paramObject));
      }
      const campaignData = sessionStorage?.getItem("utm_campaign_data") || "";
      if (campaignData && loggedInUserDetail) {
        try {
          const res = await apiClientCommon.saveCampaign({
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            params: {
              campaignData: JSON.parse(campaignData)
            }
          });
          if (res.status == 200) {
            sessionStorage.removeItem("utm_campaign_data");
          }
        } catch (error) {
          console.error("Error saving campaign:", error);
        }
      }
    })();
  }, [params, loggedInUserDetail]);
  return null;
};
export default AppUTMSessionManagement;